import { delegate, disablePageScrolling } from './utils';

export default class Navigation {
  constructor() {
    this.setBreadcrumbsWidth();
    this.toggleBodyOverflow();
    this.updatePositionOfDropdown();

    delegate('click', 'header > nav .caret-down', this.toggleSubMenu);
    delegate('click', 'header > nav .category-menu-item', this.toggleSubMenu);
    delegate(
      'mouseover',
      '.primary-nav',
      this.setTopPropertyForCategoryDropdown,
    );
    // For iPad devices
    delegate(
      'touchstart',
      '.primary-nav',
      this.setTopPropertyForCategoryDropdown,
    );

    window.addEventListener('resize', this.updatePositionOfDropdown);
  }

  updatePositionOfDropdown() {
    document.querySelectorAll('.nav-item').forEach((menuItem) => {
      const noOfDropdowns = 3;
      // width of 1 dropdown above width 1200 is `230px` and `200px` below that
      const dropdownWidth = window.innerWidth > 1200 ? 230 : 200;
      const maxSpace = dropdownWidth * noOfDropdowns;

      if (!menuItem) {
        return;
      }

      // Check if there is space on right of the `menu-item`
      if (window.innerWidth - menuItem.offsetLeft < maxSpace) {
        menuItem.classList.add('shift-to-left');
      } else {
        menuItem.classList.remove('shift-to-left');
      }
    });
  }

  setTopPropertyForCategoryDropdown(event) {
    const menuItem = event.target.closest('.primary-nav');
    const subMenu = menuItem.querySelector('.sub-menu');

    if (!subMenu || !menuItem) {
      return;
    }

    if (menuItem.classList.contains('category-dropdown-parent')) {
      subMenu.style.top = `${menuItem.offsetTop + menuItem.clientHeight - 1}px`;
    }
  }

  setBreadcrumbsWidth() {
    const crumbs = document.querySelectorAll('.crumb');
    const minWidth = 75;
    const extraSpacing = 1;

    crumbs.forEach((crumb) => {
      const crumbWidth = crumb.offsetWidth;

      if (crumbWidth < minWidth) {
        crumb.closest('li').style.minWidth = `${crumbWidth + extraSpacing}px`;
      }
    });
  }

  toggleSubMenu(e, elementSelector) {
    const target = e.target;

    // Skipping `.caret-down` element click event inside `.category-menu-item`
    // element because there will be 2 events which would nullify each other
    if (
      elementSelector.lastIndexOf('.caret-down') !== -1 &&
      target.closest('.category-menu-item')
    ) {
      return;
    }

    const li = target.closest('li');

    if (li) {
      li.classList.toggle('active');
      li.querySelector('ul').classList.toggle('active');
    }
  }

  toggleBodyOverflow() {
    const menuIcon = document.querySelector('#menu-active');

    if (menuIcon) {
      menuIcon.addEventListener('click', disablePageScrolling);
    }
  }
}
